import { themes } from '@lunary/ui-tokens'
import type { ThemeColors, ThemeName } from '@lunary/ui-tokens'

const kebab = (key: string) => key.replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`)

export function themeVars(theme: ThemeName): Record<string, string> {
  const colors: ThemeColors = themes[theme]
  const vars: Record<string, string> = {}
  for (const [key, value] of Object.entries(colors)) vars[`--${kebab(key)}`] = value
  return vars
}
